import React, { useEffect, useState } from 'react';
import "./foodSlide.scss";
import axios from 'axios';
import SwipeCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { OutlineButton } from "../button/Button";
import { Link } from 'react-router-dom';
import "swiper/css";

const FoodSlide = () => {
  SwipeCore.use([Autoplay]);
  const [foodItems, setFoodItems] = useState([]);
  useEffect(() => {
    const getFoods = async () => {
      try {
        const response = await axios.get(`https://www.themealdb.com/api/json/v1/1/filter.php?a=indian`);
        setFoodItems(response.data.meals.slice(1, 6))
        // console.log(response.data.meals.slice(1, 6));
      } catch (error) {
        console.log(error);
      }
    }
    getFoods();
  }, []);
  return (
    <div className='food-slide'>
      <Swiper
        modules={[Autoplay]}
        grabCursor={true}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{ delay: 3000 }}
      >
        {
          foodItems.map((item, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => (
              // <img src={item.strMealThumb} alt="" />
                <FoodSlideItem item={item} className={`${isActive ? 'active' : ''}`} />
              )}
            </SwiperSlide>
          ))
        }
      </Swiper>
    </div>
  )
}

const FoodSlideItem = props => {
  const item = props.item;
  const background = item.strMealThumb;
  return (
    <div
      className={`food-slide__item ${props.className}`}
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="food-slide__item__content container">
        <div className="food-slide__item__content__info">
          <h2 className="title">{item.strMeal}</h2>
          <div className="btns">
            <Link to={`/foods/${item.idMeal}`}>
              <OutlineButton>
                Make It
              </OutlineButton>
            </Link>
          </div>
        </div>

        <div className="food-slide__item__content__poster">
          <img src={background} alt="" />
        </div>
      </div>
    </div>
  )
}

export default FoodSlide